export default [
  {
    path: "/repositorioComercial",
    component: () => import("@/views/repositoriosComerciales/Listar.vue"),
  },
];
